"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.4 16.8c.004.306-.295.605-.6.6H7.2c-.301.005-.6-.294-.6-.6V9.606c0-.385.27-.64.6-.795l4.225-2.086c.33-.156.824-.177 1.2 0l4.179 2.086c.33.156.604.365.596.795V16.8zm-6.6-3.605a.6.6 0 00-.6.6V17.4h3.6v-3.605a.6.6 0 00-.6-.6h-2.4z" }), "Home");
//# sourceMappingURL=Home.js.map